import { getErrorStatus, getErrorText } from '../../../../../common/api/errors'

/** The generation service answered with something unusable — HTTP 502; a new attempt may succeed. */
export const GENERATION_BAD_RESPONSE_TEXT = 'Сервис генерации ответил ошибкой — попробуйте ещё раз'

/**
 * Text of a refusal of a template step (match, generation, mask test, save): the fixed texts for an unreachable
 * (503) or misbehaving (502) generation service, otherwise the backend sentence or field error, otherwise the message
 * of a refusal the page threw itself.
 */
export const templateErrorText = (error: unknown): string => {
  if (getErrorStatus(error) === 502) {
    return GENERATION_BAD_RESPONSE_TEXT
  }

  return getErrorText(error, (error instanceof Error ? error.message : '') || 'Unknown error')
}
